import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./button.module.scss";

const cx = classNames.bind(styles);

const size = ["small", "medium", "large"];
const variant = [
  "primary",
  "secondary",
  "tertiary",
  "inherit",
  "text",
  "blank"
];

const Button = ({
  children,
  onClick,
  size = "large",
  variant = "primary",
  isInvert = false,
  isLink = false,
  href,
  tracking,
  className,
  ...props
}) => {
  const Base = isLink ? `a` : `button`;
  const btnRef = useRef();
  const [section, setSection] = useState();
  useEffect(() => {
    if (btnRef.current && btnRef.current.closest("[data-testid]")) {
      setSection(btnRef.current.closest("[data-testid]").dataset.testid + "_");
    } else {
      setSection("");
    }
  }, [btnRef.current]);

  const getText = (rootChild) => {
    let res = "";
    const rr = (child) => {
      if (typeof child === "string" || typeof child === "number") {
        res += child;
      } else if (Array.isArray(child)) {
        child.forEach((c) => rr(c));
      } else if (child && child.props) {
        const { children } = child.props;

        if (Array.isArray(children)) {
          children.forEach((c) => rr(c));
        } else {
          rr(children);
        }
      }
    };
    rr(rootChild);
    return res;
  };

  return (
    <Base
      onClick={onClick}
      className={cx("button", size, variant, isInvert && "invert", className)}
      tabIndex="0"
      href={href}
      data-wa-link={
        tracking ||
        section + getText(children).split(" ").join("-").toLowerCase()
      }
      ref={btnRef}
      {...props}
    >
      {children}
    </Base>
  );
};

Button.PropTypes = {
  size: PropTypes.oneOf(size),
  variant: PropTypes.oneOf(variant),
  isInvert: PropTypes.bool,
  isLink: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  href: PropTypes.string,
  tracking: PropTypes.string
};

export { Button as default };
